import {defineStore} from "pinia";

export const anulacionStore = defineStore("anulacionStore", {
    state: () =>
        ({
            loading: false as boolean,
            anulaciones: [] as any[],
            anulacion: {} as any,

            motivos: [] as any[],

            isNewDialog: false as boolean,
        }),
});